// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__3L-xJ","fill":"_type_fill__1RnD6","dense":"_type_dense__1YR-d"};